/**
 * Created on 16/8/19.
 */
export const pricingMatrixIndexOfReference = 1;
export const acreInSF = 43560;
export const pmtFunction = function (rate, nperiod, pv) {
    if (rate === 0) {
        return -(pv) / nperiod;
    }
    const pvif = Math.pow(1 + rate, nperiod);
    return rate / (pvif - 1) * -(pv * pvif);
};